import {z} from 'zod';

// PDF to image conversion constants
const MIN_DENSITY_DPI = 72;
const MAX_DENSITY_DPI = 600;
const DEFAULT_DENSITY_DPI = 300;

const MIN_QUALITY_PERCENT = 1;
const MAX_QUALITY_PERCENT = 100;
const DEFAULT_QUALITY_PERCENT = 95;

const MIN_WIDTH_PIXELS = 100;
const MAX_WIDTH_PIXELS = 3000;
const DEFAULT_WIDTH_PIXELS = 1536;

/**
 * Schema for PDF to image conversion request validation
 */
export const storagePdfConvertRequestSchema = z.object({
  fileId: z.string().min(1),
  namespace: z.string().optional(),
  generatorParams: z
    .object({
      format: z.enum(['jpeg', 'webp', 'png']).default('jpeg'),
      density: z
        .number()
        .int()
        .min(MIN_DENSITY_DPI)
        .max(MAX_DENSITY_DPI)
        .default(DEFAULT_DENSITY_DPI),
      quality: z
        .number()
        .int()
        .min(MIN_QUALITY_PERCENT)
        .max(MAX_QUALITY_PERCENT)
        .default(DEFAULT_QUALITY_PERCENT),
      preserveAspectRatio: z.boolean().default(true),
      width: z
        .number()
        .int()
        .min(MIN_WIDTH_PIXELS)
        .max(MAX_WIDTH_PIXELS)
        .default(DEFAULT_WIDTH_PIXELS),
    })
    .optional(),
  webhookUrls: z.array(z.string().url()).optional(),
});

export type StoragePdfConvertRequest = z.infer<typeof storagePdfConvertRequestSchema>;
